import createWebEnvironment from './createEnv';

const environment = createWebEnvironment();
export default environment;
